import { useState } from 'react'
import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect'

const ssrFallbackWindowDimensions = {
  innerWidth: 1024, // greater than DESKTOP_MIN_WIDTH
  innerHeight: 768, // greater than NORMAL_DESKTOP_MIN_HEIGHT
  devicePixelRatio: 1,
}

const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState(() => ({
    innerWidth: ssrFallbackWindowDimensions.innerWidth,
    innerHeight: ssrFallbackWindowDimensions.innerHeight,
  }))

  useIsomorphicLayoutEffect(() => {
    const update = () => {
      setDimensions({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      })
    }

    update()

    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return dimensions
}

const getSafeWindowDimensions = () =>
  typeof window !== 'undefined'
    ? {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio,
      }
    : ssrFallbackWindowDimensions

export default useWindowDimensions
export { getSafeWindowDimensions }
